import { all } from 'redux-saga/effects';

import consultaNomeSocialSaga from './consultaNomeSocial/saga';

export default all([consultaNomeSocialSaga]);
